import { render, staticRenderFns } from "./SysDashboardSetting.vue?vue&type=template&id=f7d9d280"
import script from "./SysDashboardSetting.vue?vue&type=script&lang=js"
export * from "./SysDashboardSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports